/**
 *
 * @param {Map<"x" | "y", any>} pointer
 * @param {"x" | "y"} axis
 * @param {Number} dimension
 * @returns {Number}
 */
const getPointerContinuousPercents = (pointer, axis, dimension) => {
  return 1 - (dimension / 2 - pointer.get(axis)) / (dimension / 2);
}

export default getPointerContinuousPercents;